import { httpRequest } from "@/utils/HttpRequest";
import { ISearchPage, IPage } from "@/types/ScmTypes";

export interface IIncomeSummaryDetail {
    id: string | number
    day: number, // "12",                          			日期
    saleTotalAmount: number, // 34451.83,					销售金额	
    sreturnTotalAmount: number, // 15401.6,					销退金额
    saleAmount: number, //19050.23,							销售数量
    materialScienceAmount: number, // null,					维修服务配件金额
    workingHoursAmount: number, // null,						维修服务工时金额
    claimMaterialScienceAmount: number, // 892.7,			索赔服务配件金额
    claimWorkingHoursAmount: number, // 90,					索赔服务工时金额
    maintainMaterialScienceAmount: number, // null,			保养服务配件金额
    maintainWorkingHoursAmount: number, // null,				保养服务工时金额
    contractMaterialScienceAmount: number, // null,			保养合约配件金额
    contractWorkingHoursAmount: number, // null,				保养合约工时金额
    accidentMaterialScienceAmount: number, // null,			事故车配件金额
    accidentWorkingHoursAmount: number, // null,				事故车工时金额
    totalAmount: number, // null"							合计
}

//搜索条件
export interface IIncomeSummarySearchFields {
    shopId?: string, //"站点id",
    tradeTypeCode?: string, //"单据类型",
    startTime?: string, //"制单开始时间",
    EndTime?: string, //"制单结束时间",
    settlementStartTime?: string, //"结算开始时间",
    settlementEndTime?: string, //"结算结束时间"
}

export interface IIncomeSummarySearch
    extends IIncomeSummarySearchFields, ISearchPage {
}
//收入汇总
export interface ISummaryDetail {
    id: string | number
    day: number, // "13",
    saleTotalAmount: number, // null,
    sreturnTotalAmount: number, // null,
    saleAmount: number, // 3709351.01,                 配件金额     
    materialScienceAmount: number, // 2226641.81,    
    workingHoursAmount: number, // 0,                  工时费用
    claimMaterialScienceAmount: number, // 0,
    claimWorkingHoursAmount: number, // 0,
    maintainMaterialScienceAmount: number, // 0,
    maintainWorkingHoursAmount: number, // 0,
    contractMaterialScienceAmount: number, // 0,
    contractWorkingHoursAmount: number, // 0,
    accidentMaterialScienceAmount: number, // 0,
    accidentWorkingHoursAmount: number, // 0,
    totalAmount: number, // 7039054.71
}
// 全年成本
export interface IAnnualCostDetail {
    id: string | number
    day: number, // "13",
    saleTotalAmount: number, // null,
    sreturnTotalAmount: number, // null,
    saleAmount: number, // 3709351.01,                 配件金额     
    materialScienceAmount: number, // 2226641.81,    
    workingHoursAmount: number, // 0,                  工时费用
    claimMaterialScienceAmount: number, // 0,
    claimWorkingHoursAmount: number, // 0,
    maintainMaterialScienceAmount: number, // 0,
    maintainWorkingHoursAmount: number, // 0,
    contractMaterialScienceAmount: number, // 0,
    contractWorkingHoursAmount: number, // 0,
    accidentMaterialScienceAmount: number, // 0,
    accidentWorkingHoursAmount: number, // 0,
    totalAmount: number, // 7039054.71
}
// 收入明细
export interface IIncomeDetail {
    documentNumber?: string, // "XLWWX2021110501",               单号
    tradeTypeCode?: string, // "trade-type.maintenance",        单据类型
    customerName?: string, // "全速顺达有限公司",                 客户名称   
    customerTypeCode?: string, // null,                         客户类型
    customerTypeName?: string, // null,
    shopName?: string, // "新疆新陆王",                          站点名称    
    shopId?: string, // "6f5d134fe0ec32a28c54514086c1abe8",
    tradeTypeName?: string, // "维修",                          单据类型                         
    totalAmount?: number, // 920,                               结算金额              
    discountTotalAmount?: number, // 0,                         优惠总金额              
    materialScienceAmount?: number, // 0,                       配件金额  
    workingHoursAmount?: number, // 920,                        工时费  
    createUser?: string, // "毕思文",                            操作员
    settleTime?: string, // null,                               结算日期 
    createTime?: string, // "2021-11-05",              创建时间      
    note?: string, // null,                                     备注
    payStatus?: string, // "pay-status.bill",                   支付状态
    serviceNatureCode?: string, // "repair-type.claim",         维修类型
    serviceNatureName?: string, // "索赔服务",
    paidAmount?: string, // 1742.82,                            实收金额
    payType?: string, // "settle-type.credit",                  结算方式
    [key: string]: any
}
export interface IIncomeDetailSearch extends IIncomeDetail, ISearchPage {
    shopId?: string, //"站点id",
    tradeTypeCode?: string, //"单据类型",
    startTime?: string, //"制单开始时间",
    EndTime?: string, //"制单结束时间",
    settlementStartTime?: string, //"结算开始时间",
    settlementEndTime?: string, //"结算结束时间"
}
//进销存报表
class IncomeSummaryService {
    async page(shopid: string) {
        const apiUrl = `/zzw-vrm/statistics/annualStatistics/${shopid}`;
        return await httpRequest.get<IIncomeSummaryDetail[]>(apiUrl);
    }

    //收入汇总
    async summary(shopid: string) {
        const apiUrl = `/zzw-vrm/statistics/summary/${shopid}`;
        return await httpRequest.get<ISummaryDetail[]>(apiUrl);
    }
    //收入明细
    async income(searchVo: IIncomeDetailSearch) {
        const apiUrl = `/zzw-vrm/statistics/income/details`;
        return await httpRequest.post<IPage<ISummaryDetail>>(apiUrl, searchVo);
    }
    async export(searchVo: IIncomeDetailSearch) {
        const apiUrl = "/zzw-vrm/statistics/income/export";
        return await httpRequest.postFile(apiUrl, searchVo, { timeout: 300000 });
    }

}

export const incomeSummaryService = new IncomeSummaryService();

export enum IIncomeEnum {
    ANNUALINCOME,//全年收入
    ANNUALCOST,//全年成本
    INCOMESUMMARY,//收入汇总
    INCOMEDETAILS,//收入明细
}